<template>
 <div class="ui vertical segment">
   <app-header v-if="showMenu" ></app-header>
    <div class="ui container">
        <div :class="[{'vuetable-wrapper ui basic segment': true}, loading]">
            <form class="ui form segment">
            <div id="demo" class="ui vertical stripe segment">
              <div class="ui block header">
                  <div class="four fields">
                      <div class="field">
                          <label>User Name</label>
                          <label >{{ this.user_name }} </label>
                      </div>
                      <div class="field">
                          <label>Email</label>
                          <label >{{ this.email }}</label>
                      </div>
                      <div class="field">
                          <label>First Name</label>
                          <label >{{ this.first_name }}</label>
                      </div>
                      <div class="field">
                          <label>Last Name</label>
                          <label >{{ this.last_name }}</label>
                      </div>
                  </div>
              </div>  
              <div class="three fields">
                <div class="field">
                   <h5>Available Modules in the System </h5> 
                  <select v-model="selected" multiple  style="width:350px;height:300px">
                  <option v-for="module in modules" v-bind:value="module.moduleId" v-bind:key="module.moduleId" >
                              {{ module.moduleName }} 
                  </option>
                  </select>
                  <br>
                </div>
                <div class="field">
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <div class="ui green button" @click="addToMappedModules()">Add Modules >></div>  
                </div>
                <div class="field">
                  <h5>
                  Mapped modules for {{ this.first_name }}   {{ this.last_name }}
                  </h5>
                  <select v-model="selected_mapped_modules" multiple  style="width:350px;height:300px">
                  <option v-for="module in mapped_modules" v-bind:value="module.moduleId" v-bind:key="module.moduleId" >
                    {{ module.moduleName }}
                  </option>
                  </select>
                </div>
                <div class="field">
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <div class="ui red button" @click="removeFromMappedModules()">Remove</div>  
                </div>
                 
              </div>
              
              <div class="one field">
                  <div class="field">
                    <div class="ui primary submit button" @click="createMapping()">Save</div>  
                      <div class="ui button"  @click="closeWindow()">Close Current Window</div>
                  </div>
              </div>    
          </div>
            </form> 
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios";
import Header from '@/components/Header.vue';
import Vue from 'vue'


export default {
components: {
    appHeader: Header
  },
data () {
    return {
      loaded : "2",
      loading: '',
      showMenu :false,
      tokenExpired : 0,
      input: {
        refreshtoken : ""
      }   ,
      diffMins : 0,
      refreshToken_Event_Fired : 0 ,
      application_Error : "",
      modules : [],
      user_id : '',
      user_name : '',
      email : '',
      first_name : '',
      last_name :'',
      mapped_modules : [],
      selected : [],
      temp_modules  :[],
      selected_mapped_modules  :[],
      input: {
      moduleIds : [] ,
      user_id :''
      }
    }
  },
  methods: {
      sessionExpired(errorStatus){
      if (errorStatus === 403 && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Sesssion expired.Please login again!!');
        this.$router.push({name: 'Login'});
    }
   },
    checkTokenExpired(){
    if(this.refreshToken_Event_Fired == 0){
    this.getTokenExpiryTime();/* Get Token Expiry time  in Minutes */
    if(this.diffMins <= Vue.prototype.$session_Expire_in && this.diffMins > 0  ){ /* If Token Expiring in (expires_in from service) Mins,then get refereh token */
      this.refreshToken_Event_Fired = 1 ;
      this.getRefreshToken();
      this.refreshToken_Event_Fired = 0;
      }
     }
    },
    async getRefreshToken() {
    this.input['refreshtoken'] = localStorage.getItem('refresh_token')
    await axios({ method: "POST", "url": Vue.prototype.$appName + "token/refreshtoken", 
      "data": this.input, 
      "headers": { "Access-Control-Allow-Origin" : "*",
      "content-type": "application/json" } }).then
      (
          result => {
          this.response = result.data;
          localStorage.setItem('id_token', result.data.access_token);
          localStorage.setItem('refresh_token', result.data.refresh_token);

          var now = new Date();
          now.setMinutes(now.getMinutes() + Math.floor(result.data.expires_in / 60)  ); // timestamp
          now = new Date(now); // Date object
          localStorage.setItem('expiry_date', now);
         }, 
      error => {
        this.refreshToken_Event_Fired = 0;
        console.error(error);
      });

    },
    getTokenExpiryTime() {
      var expiry_date =  new Date(localStorage.getItem('expiry_date'));
      var today = new Date();
      var diffMs = (expiry_date - today); // milliseconds between now & logintime
      this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
       
    },
    bindHeaderData(){
   
   
         axios({ method: "GET", "url": Vue.prototype.$hostname + "getuserdetails/" + this.user_id , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.headerData = result.data;
                    console.log('Header Data');
                    console.log(this.headerData);
                    this.user_name = this.headerData[0].userName;
                    this.email = this.headerData[0].email;
                    this.first_name = this.headerData[0].firstName;
                    this.last_name = this.headerData[0].lastName;

               }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
          
    },
    bindUserModules(){
   
   
         axios({ method: "GET", "url": Vue.prototype.$hostname + "getrolemappinglist/" + this.user_id , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.temp_modules  = result.data;
                    for (let i = 0; i <  this.temp_modules.length; i++) {
                    
                      if(this.temp_modules[i].moduleId != null ){
                        this.mapped_modules = result.data;
                        break;
                        //this.mapped_modules = result.data;
                      }
                    }

               }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
          
    },
    bindActiveModules(){
    axios({ method: "GET", "url": Vue.prototype.$hostname + "getmodules"  , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.modules = result.data;
                    

               }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
          
    },
    addToMappedModules(){

      if(this.selected.length<1)swal("",  "Please select the module(s) from available module list.", "error");

       for (let i = 0; i <  this.selected.length; i++) {
        let flag = 0;
          for (let j = 0; j <  this.mapped_modules.length; j++) {
            if( this.selected[i] ===  this.mapped_modules[j].moduleId) 
              flag = 1;
            }

      
        //if(flag == 0)
       /// this.mapped_modules.push({moduleId: this.selected[i] , moduleName: this.modules.filter(x=> x.moduleId === this.selected[i])[0].moduleName})
        if(flag == 1)swal("", this.modules.filter(x=> x.moduleId === this.selected[i])[0].moduleName + ' is already added', "error");
        else this.mapped_modules.push({moduleId: this.selected[i] , moduleName: this.modules.filter(x=> x.moduleId === this.selected[i])[0].moduleName})
       }
    },
    removeFromMappedModules(){

     if(this.selected_mapped_modules.length<1)swal("",  "Please select the module(s) from mapped module list.", "error");
    for (let i = 0; i <  this.selected_mapped_modules.length; i++) {
        var index = -1;
        var val = this.selected_mapped_modules[i];
        var filteredObj = this.mapped_modules.find(function(item, i){
          if(item.moduleId === val){
            index = i;
            return i;
          }
        });
        if(index > -1)
        this.mapped_modules.splice(index,1);
      }
    },
    createMapping(){
     
      for (let i = 0; i <  this.mapped_modules.length; i++) {
        this.input.moduleIds.push(this.mapped_modules[i].moduleId)
      }
      console.log( this.input.moduleIds);
      this.input.user_id = this.user_id ;

    
      swal({
        title: "",
        text: "Are you sure ,to map the modules added?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, add it!",
        closeOnConfirm: true
      },() => {
        
         axios({ method: "POST", "url": Vue.prototype.$hostname + "mapusermodules", 
                  "data": this.input, 
                    "headers": { 
                          "content-type": "application/json",
                          "authorization": "bearer " + localStorage.getItem('id_token')    } }).then
                    (
                        result => {
                       if(result.data[0].result_Code == "1")
                       swal("", result.data[0].result_Output, "success");
                      }, 
                   error => {
                console.error(error);
                if(!error.response)
                swal("", 'Network Error : Something\'s Wrong!', "error");
                else
                swal("", error.response, "error");
                   }
                    );  
        
      })
    },
   
  closeWindow(){
   window.close();
  }
  },
   created() {
     if(!localStorage.getItem('id_token')){
    this.$router.push({name: 'Login'});
    }else
    {
       this.user_id = CryptoJS.AES.decrypt( this.$route.query.uid, 'corcentric').toString(CryptoJS.enc.Latin1);
       this.bindHeaderData();
       this.bindActiveModules();
       this.bindUserModules();
    }
  }
  
}
</script>


// WEBPACK FOOTER //
// src/components/manage-user/UserModuleMapping.vue